{
  "version": "52a0360735940f0b",
  "_generated_by": "python manage.py dump_alert_metric_contract, from apps/alerts/metrics/registry.py. Do not edit by hand.",
  "global_metrics": {
    "station": [
      {
        "metric": "T",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "U",
        "dimension": "HUMIDITY_PCT"
      },
      {
        "metric": "FF",
        "dimension": "SPEED"
      },
      {
        "metric": "FXY",
        "dimension": "SPEED"
      },
      {
        "metric": "RR_1H",
        "dimension": "RAIN"
      },
      {
        "metric": "RR_RATE",
        "dimension": "RAIN_RATE"
      },
      {
        "metric": "RR_TODAY",
        "dimension": "RAIN"
      },
      {
        "metric": "SLP",
        "dimension": "PRESSURE"
      },
      {
        "metric": "UV",
        "dimension": "UV_INDEX"
      },
      {
        "metric": "SOLAR_RADIATION",
        "dimension": "SOLAR_IRRADIANCE"
      },
      {
        "metric": "VIS",
        "dimension": "DISTANCE_LONG"
      },
      {
        "metric": "AQI",
        "dimension": "AQI_INDEX"
      },
      {
        "metric": "PM_1",
        "dimension": "PM_CONCENTRATION"
      },
      {
        "metric": "PM_10",
        "dimension": "PM_CONCENTRATION"
      },
      {
        "metric": "PM_2P5",
        "dimension": "PM_CONCENTRATION"
      },
      {
        "metric": "HEAT_INDEX",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "WIND_CHILL",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "HUMIDEX",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "THW",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "THSW",
        "dimension": "TEMPERATURE"
      }
    ],
    "netatmo": [
      {
        "metric": "T",
        "dimension": "TEMPERATURE"
      },
      {
        "metric": "U",
        "dimension": "HUMIDITY_PCT"
      },
      {
        "metric": "FF",
        "dimension": "SPEED"
      },
      {
        "metric": "FXY",
        "dimension": "SPEED"
      },
      {
        "metric": "RR_1H",
        "dimension": "RAIN"
      },
      {
        "metric": "RR_RATE",
        "dimension": "RAIN_RATE"
      },
      {
        "metric": "RR_TODAY",
        "dimension": "RAIN"
      },
      {
        "metric": "SLP",
        "dimension": "PRESSURE"
      },
      {
        "metric": "CO2",
        "dimension": "CO2_PPM"
      },
      {
        "metric": "NOISE",
        "dimension": "NOISE_DB"
      }
    ]
  },
  "sensor_families": [
    "indoor",
    "soil",
    "soil_ec",
    "leaf",
    "temp_humidity",
    "temp",
    "pm25",
    "netatmo_module"
  ],
  "quantities": [
    "temperature",
    "humidity",
    "co2",
    "pm25",
    "aqi",
    "soil_moisture",
    "leaf_wetness",
    "noise"
  ],
  "quantity_sentences": {
    "temperature": {
      "less_than": "Temperature of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "Temperature of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "humidity": {
      "less_than": "Humidity of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "Humidity of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "co2": {
      "less_than": "CO2 of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "CO2 of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "pm25": {
      "less_than": "PM 2.5 of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "PM 2.5 of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "aqi": {
      "less_than": "AQI of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "AQI of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "soil_moisture": {
      "less_than": "Soil moisture of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "Soil moisture of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "leaf_wetness": {
      "less_than": "Leaf wetness of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "Leaf wetness of {value}{unit} greater than {threshold}{unit} threshold"
    },
    "noise": {
      "less_than": "Noise of {value}{unit} less than {threshold}{unit} threshold",
      "greater_than": "Noise of {value}{unit} greater than {threshold}{unit} threshold"
    }
  },
  "sensor_readings": [
    {
      "family": "indoor",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "indoor",
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity"
    },
    {
      "family": "indoor",
      "dimension": "CO2_PPM",
      "quantity": "co2"
    },
    {
      "family": "indoor",
      "dimension": "NOISE_DB",
      "quantity": "noise"
    },
    {
      "family": "soil",
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture"
    },
    {
      "family": "soil",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "soil_ec",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "soil_ec",
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture"
    },
    {
      "family": "leaf",
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness"
    },
    {
      "family": "temp_humidity",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "temp_humidity",
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity"
    },
    {
      "family": "temp",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "pm25",
      "dimension": "PM_CONCENTRATION",
      "quantity": "pm25"
    },
    {
      "family": "pm25",
      "dimension": "AQI_INDEX",
      "quantity": "aqi"
    },
    {
      "family": "netatmo_module",
      "dimension": "TEMPERATURE",
      "quantity": "temperature"
    },
    {
      "family": "netatmo_module",
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity"
    },
    {
      "family": "netatmo_module",
      "dimension": "CO2_PPM",
      "quantity": "co2"
    }
  ],
  "sensor_metrics": [
    {
      "metric": "INDOOR_T",
      "family": "indoor",
      "channel": null,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "",
      "default_name": null
    },
    {
      "metric": "INDOOR_U",
      "family": "indoor",
      "channel": null,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "",
      "default_name": null
    },
    {
      "metric": "INDOOR_CO2",
      "family": "indoor",
      "channel": null,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "",
      "default_name": null
    },
    {
      "metric": "INDOOR_NOISE",
      "family": "indoor",
      "channel": null,
      "dimension": "NOISE_DB",
      "quantity": "noise",
      "name_key": "",
      "default_name": null
    },
    {
      "metric": "SOIL_CH1_U",
      "family": "soil",
      "channel": 1,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "SOIL_CH2_U",
      "family": "soil",
      "channel": 2,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "SOIL_CH3_U",
      "family": "soil",
      "channel": 3,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "SOIL_CH4_U",
      "family": "soil",
      "channel": 4,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "SOIL_CH5_U",
      "family": "soil",
      "channel": 5,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "SOIL_CH6_U",
      "family": "soil",
      "channel": 6,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "SOIL_CH7_U",
      "family": "soil",
      "channel": 7,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "SOIL_CH8_U",
      "family": "soil",
      "channel": 8,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "SOIL_CH9_U",
      "family": "soil",
      "channel": 9,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH9_",
      "default_name": "Ch9"
    },
    {
      "metric": "SOIL_CH10_U",
      "family": "soil",
      "channel": 10,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH10_",
      "default_name": "Ch10"
    },
    {
      "metric": "SOIL_CH11_U",
      "family": "soil",
      "channel": 11,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH11_",
      "default_name": "Ch11"
    },
    {
      "metric": "SOIL_CH12_U",
      "family": "soil",
      "channel": 12,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH12_",
      "default_name": "Ch12"
    },
    {
      "metric": "SOIL_CH13_U",
      "family": "soil",
      "channel": 13,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH13_",
      "default_name": "Ch13"
    },
    {
      "metric": "SOIL_CH14_U",
      "family": "soil",
      "channel": 14,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH14_",
      "default_name": "Ch14"
    },
    {
      "metric": "SOIL_CH15_U",
      "family": "soil",
      "channel": 15,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH15_",
      "default_name": "Ch15"
    },
    {
      "metric": "SOIL_CH16_U",
      "family": "soil",
      "channel": 16,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_CH16_",
      "default_name": "Ch16"
    },
    {
      "metric": "SOIL_CH1_T",
      "family": "soil",
      "channel": 1,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "SOIL_CH2_T",
      "family": "soil",
      "channel": 2,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "SOIL_CH3_T",
      "family": "soil",
      "channel": 3,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "SOIL_CH4_T",
      "family": "soil",
      "channel": 4,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "SOIL_CH5_T",
      "family": "soil",
      "channel": 5,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "SOIL_CH6_T",
      "family": "soil",
      "channel": 6,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "SOIL_CH7_T",
      "family": "soil",
      "channel": 7,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "SOIL_CH8_T",
      "family": "soil",
      "channel": 8,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "SOIL_EC_CH1_T",
      "family": "soil_ec",
      "channel": 1,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "SOIL_EC_CH2_T",
      "family": "soil_ec",
      "channel": 2,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "SOIL_EC_CH3_T",
      "family": "soil_ec",
      "channel": 3,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "SOIL_EC_CH4_T",
      "family": "soil_ec",
      "channel": 4,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "SOIL_EC_CH5_T",
      "family": "soil_ec",
      "channel": 5,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "SOIL_EC_CH6_T",
      "family": "soil_ec",
      "channel": 6,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "SOIL_EC_CH7_T",
      "family": "soil_ec",
      "channel": 7,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "SOIL_EC_CH8_T",
      "family": "soil_ec",
      "channel": 8,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "SOIL_EC_CH9_T",
      "family": "soil_ec",
      "channel": 9,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH9_",
      "default_name": "Ch9"
    },
    {
      "metric": "SOIL_EC_CH10_T",
      "family": "soil_ec",
      "channel": 10,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH10_",
      "default_name": "Ch10"
    },
    {
      "metric": "SOIL_EC_CH11_T",
      "family": "soil_ec",
      "channel": 11,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH11_",
      "default_name": "Ch11"
    },
    {
      "metric": "SOIL_EC_CH12_T",
      "family": "soil_ec",
      "channel": 12,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH12_",
      "default_name": "Ch12"
    },
    {
      "metric": "SOIL_EC_CH13_T",
      "family": "soil_ec",
      "channel": 13,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH13_",
      "default_name": "Ch13"
    },
    {
      "metric": "SOIL_EC_CH14_T",
      "family": "soil_ec",
      "channel": 14,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH14_",
      "default_name": "Ch14"
    },
    {
      "metric": "SOIL_EC_CH15_T",
      "family": "soil_ec",
      "channel": 15,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH15_",
      "default_name": "Ch15"
    },
    {
      "metric": "SOIL_EC_CH16_T",
      "family": "soil_ec",
      "channel": 16,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "SOIL_EC_CH16_",
      "default_name": "Ch16"
    },
    {
      "metric": "SOIL_EC_CH1_U",
      "family": "soil_ec",
      "channel": 1,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "SOIL_EC_CH2_U",
      "family": "soil_ec",
      "channel": 2,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "SOIL_EC_CH3_U",
      "family": "soil_ec",
      "channel": 3,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "SOIL_EC_CH4_U",
      "family": "soil_ec",
      "channel": 4,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "SOIL_EC_CH5_U",
      "family": "soil_ec",
      "channel": 5,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "SOIL_EC_CH6_U",
      "family": "soil_ec",
      "channel": 6,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "SOIL_EC_CH7_U",
      "family": "soil_ec",
      "channel": 7,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "SOIL_EC_CH8_U",
      "family": "soil_ec",
      "channel": 8,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "SOIL_EC_CH9_U",
      "family": "soil_ec",
      "channel": 9,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH9_",
      "default_name": "Ch9"
    },
    {
      "metric": "SOIL_EC_CH10_U",
      "family": "soil_ec",
      "channel": 10,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH10_",
      "default_name": "Ch10"
    },
    {
      "metric": "SOIL_EC_CH11_U",
      "family": "soil_ec",
      "channel": 11,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH11_",
      "default_name": "Ch11"
    },
    {
      "metric": "SOIL_EC_CH12_U",
      "family": "soil_ec",
      "channel": 12,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH12_",
      "default_name": "Ch12"
    },
    {
      "metric": "SOIL_EC_CH13_U",
      "family": "soil_ec",
      "channel": 13,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH13_",
      "default_name": "Ch13"
    },
    {
      "metric": "SOIL_EC_CH14_U",
      "family": "soil_ec",
      "channel": 14,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH14_",
      "default_name": "Ch14"
    },
    {
      "metric": "SOIL_EC_CH15_U",
      "family": "soil_ec",
      "channel": 15,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH15_",
      "default_name": "Ch15"
    },
    {
      "metric": "SOIL_EC_CH16_U",
      "family": "soil_ec",
      "channel": 16,
      "dimension": "HUMIDITY_PCT",
      "quantity": "soil_moisture",
      "name_key": "SOIL_EC_CH16_",
      "default_name": "Ch16"
    },
    {
      "metric": "LEAF_WETNESS_CH1",
      "family": "leaf",
      "channel": 1,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH1",
      "default_name": "Ch1"
    },
    {
      "metric": "LEAF_WETNESS_CH2",
      "family": "leaf",
      "channel": 2,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH2",
      "default_name": "Ch2"
    },
    {
      "metric": "LEAF_WETNESS_CH3",
      "family": "leaf",
      "channel": 3,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH3",
      "default_name": "Ch3"
    },
    {
      "metric": "LEAF_WETNESS_CH4",
      "family": "leaf",
      "channel": 4,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH4",
      "default_name": "Ch4"
    },
    {
      "metric": "LEAF_WETNESS_CH5",
      "family": "leaf",
      "channel": 5,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH5",
      "default_name": "Ch5"
    },
    {
      "metric": "LEAF_WETNESS_CH6",
      "family": "leaf",
      "channel": 6,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH6",
      "default_name": "Ch6"
    },
    {
      "metric": "LEAF_WETNESS_CH7",
      "family": "leaf",
      "channel": 7,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH7",
      "default_name": "Ch7"
    },
    {
      "metric": "LEAF_WETNESS_CH8",
      "family": "leaf",
      "channel": 8,
      "dimension": "HUMIDITY_PCT",
      "quantity": "leaf_wetness",
      "name_key": "LEAF_WETNESS_CH8",
      "default_name": "Ch8"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH1_T",
      "family": "temp_humidity",
      "channel": 1,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH1_",
      "default_name": "Ch1 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH2_T",
      "family": "temp_humidity",
      "channel": 2,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH2_",
      "default_name": "Ch2 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH3_T",
      "family": "temp_humidity",
      "channel": 3,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH3_",
      "default_name": "Ch3 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH4_T",
      "family": "temp_humidity",
      "channel": 4,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH4_",
      "default_name": "Ch4 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH5_T",
      "family": "temp_humidity",
      "channel": 5,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH5_",
      "default_name": "Ch5 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH6_T",
      "family": "temp_humidity",
      "channel": 6,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH6_",
      "default_name": "Ch6 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH7_T",
      "family": "temp_humidity",
      "channel": 7,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH7_",
      "default_name": "Ch7 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH8_T",
      "family": "temp_humidity",
      "channel": 8,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH8_",
      "default_name": "Ch8 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH9_T",
      "family": "temp_humidity",
      "channel": 9,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_AND_HUMIDITY_CH9_",
      "default_name": "Ch9 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH1_U",
      "family": "temp_humidity",
      "channel": 1,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH1_",
      "default_name": "Ch1 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH2_U",
      "family": "temp_humidity",
      "channel": 2,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH2_",
      "default_name": "Ch2 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH3_U",
      "family": "temp_humidity",
      "channel": 3,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH3_",
      "default_name": "Ch3 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH4_U",
      "family": "temp_humidity",
      "channel": 4,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH4_",
      "default_name": "Ch4 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH5_U",
      "family": "temp_humidity",
      "channel": 5,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH5_",
      "default_name": "Ch5 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH6_U",
      "family": "temp_humidity",
      "channel": 6,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH6_",
      "default_name": "Ch6 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH7_U",
      "family": "temp_humidity",
      "channel": 7,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH7_",
      "default_name": "Ch7 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH8_U",
      "family": "temp_humidity",
      "channel": 8,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH8_",
      "default_name": "Ch8 T+H"
    },
    {
      "metric": "TEMP_AND_HUMIDITY_CH9_U",
      "family": "temp_humidity",
      "channel": 9,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "TEMP_AND_HUMIDITY_CH9_",
      "default_name": "Ch9 T+H"
    },
    {
      "metric": "TEMP_CH1_T",
      "family": "temp",
      "channel": 1,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH1_",
      "default_name": "Ch1 T"
    },
    {
      "metric": "TEMP_CH2_T",
      "family": "temp",
      "channel": 2,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH2_",
      "default_name": "Ch2 T"
    },
    {
      "metric": "TEMP_CH3_T",
      "family": "temp",
      "channel": 3,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH3_",
      "default_name": "Ch3 T"
    },
    {
      "metric": "TEMP_CH4_T",
      "family": "temp",
      "channel": 4,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH4_",
      "default_name": "Ch4 T"
    },
    {
      "metric": "TEMP_CH5_T",
      "family": "temp",
      "channel": 5,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH5_",
      "default_name": "Ch5 T"
    },
    {
      "metric": "TEMP_CH6_T",
      "family": "temp",
      "channel": 6,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH6_",
      "default_name": "Ch6 T"
    },
    {
      "metric": "TEMP_CH7_T",
      "family": "temp",
      "channel": 7,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH7_",
      "default_name": "Ch7 T"
    },
    {
      "metric": "TEMP_CH8_T",
      "family": "temp",
      "channel": 8,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "TEMP_CH8_",
      "default_name": "Ch8 T"
    },
    {
      "metric": "PM25_CH1_PM25",
      "family": "pm25",
      "channel": 1,
      "dimension": "PM_CONCENTRATION",
      "quantity": "pm25",
      "name_key": "PM25_CH1_PM25",
      "default_name": "Ch1"
    },
    {
      "metric": "PM25_CH2_PM25",
      "family": "pm25",
      "channel": 2,
      "dimension": "PM_CONCENTRATION",
      "quantity": "pm25",
      "name_key": "PM25_CH2_PM25",
      "default_name": "Ch2"
    },
    {
      "metric": "PM25_CH3_PM25",
      "family": "pm25",
      "channel": 3,
      "dimension": "PM_CONCENTRATION",
      "quantity": "pm25",
      "name_key": "PM25_CH3_PM25",
      "default_name": "Ch3"
    },
    {
      "metric": "PM25_CH4_PM25",
      "family": "pm25",
      "channel": 4,
      "dimension": "PM_CONCENTRATION",
      "quantity": "pm25",
      "name_key": "PM25_CH4_PM25",
      "default_name": "Ch4"
    },
    {
      "metric": "PM25_CH1_AQI",
      "family": "pm25",
      "channel": 1,
      "dimension": "AQI_INDEX",
      "quantity": "aqi",
      "name_key": "PM25_CH1_PM25",
      "default_name": "Ch1"
    },
    {
      "metric": "PM25_CH2_AQI",
      "family": "pm25",
      "channel": 2,
      "dimension": "AQI_INDEX",
      "quantity": "aqi",
      "name_key": "PM25_CH2_PM25",
      "default_name": "Ch2"
    },
    {
      "metric": "PM25_CH3_AQI",
      "family": "pm25",
      "channel": 3,
      "dimension": "AQI_INDEX",
      "quantity": "aqi",
      "name_key": "PM25_CH3_PM25",
      "default_name": "Ch3"
    },
    {
      "metric": "PM25_CH4_AQI",
      "family": "pm25",
      "channel": 4,
      "dimension": "AQI_INDEX",
      "quantity": "aqi",
      "name_key": "PM25_CH4_PM25",
      "default_name": "Ch4"
    },
    {
      "metric": "NETATMO_MODULE_CH1_T",
      "family": "netatmo_module",
      "channel": 1,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "NETATMO_MODULE_CH2_T",
      "family": "netatmo_module",
      "channel": 2,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "NETATMO_MODULE_CH3_T",
      "family": "netatmo_module",
      "channel": 3,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "NETATMO_MODULE_CH4_T",
      "family": "netatmo_module",
      "channel": 4,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "NETATMO_MODULE_CH5_T",
      "family": "netatmo_module",
      "channel": 5,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "NETATMO_MODULE_CH6_T",
      "family": "netatmo_module",
      "channel": 6,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "NETATMO_MODULE_CH7_T",
      "family": "netatmo_module",
      "channel": 7,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "NETATMO_MODULE_CH8_T",
      "family": "netatmo_module",
      "channel": 8,
      "dimension": "TEMPERATURE",
      "quantity": "temperature",
      "name_key": "NETATMO_MODULE_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "NETATMO_MODULE_CH1_U",
      "family": "netatmo_module",
      "channel": 1,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "NETATMO_MODULE_CH2_U",
      "family": "netatmo_module",
      "channel": 2,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "NETATMO_MODULE_CH3_U",
      "family": "netatmo_module",
      "channel": 3,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "NETATMO_MODULE_CH4_U",
      "family": "netatmo_module",
      "channel": 4,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "NETATMO_MODULE_CH5_U",
      "family": "netatmo_module",
      "channel": 5,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "NETATMO_MODULE_CH6_U",
      "family": "netatmo_module",
      "channel": 6,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "NETATMO_MODULE_CH7_U",
      "family": "netatmo_module",
      "channel": 7,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "NETATMO_MODULE_CH8_U",
      "family": "netatmo_module",
      "channel": 8,
      "dimension": "HUMIDITY_PCT",
      "quantity": "humidity",
      "name_key": "NETATMO_MODULE_CH8_",
      "default_name": "Ch8"
    },
    {
      "metric": "NETATMO_MODULE_CH1_CO2",
      "family": "netatmo_module",
      "channel": 1,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH1_",
      "default_name": "Ch1"
    },
    {
      "metric": "NETATMO_MODULE_CH2_CO2",
      "family": "netatmo_module",
      "channel": 2,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH2_",
      "default_name": "Ch2"
    },
    {
      "metric": "NETATMO_MODULE_CH3_CO2",
      "family": "netatmo_module",
      "channel": 3,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH3_",
      "default_name": "Ch3"
    },
    {
      "metric": "NETATMO_MODULE_CH4_CO2",
      "family": "netatmo_module",
      "channel": 4,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH4_",
      "default_name": "Ch4"
    },
    {
      "metric": "NETATMO_MODULE_CH5_CO2",
      "family": "netatmo_module",
      "channel": 5,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH5_",
      "default_name": "Ch5"
    },
    {
      "metric": "NETATMO_MODULE_CH6_CO2",
      "family": "netatmo_module",
      "channel": 6,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH6_",
      "default_name": "Ch6"
    },
    {
      "metric": "NETATMO_MODULE_CH7_CO2",
      "family": "netatmo_module",
      "channel": 7,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH7_",
      "default_name": "Ch7"
    },
    {
      "metric": "NETATMO_MODULE_CH8_CO2",
      "family": "netatmo_module",
      "channel": 8,
      "dimension": "CO2_PPM",
      "quantity": "co2",
      "name_key": "NETATMO_MODULE_CH8_",
      "default_name": "Ch8"
    }
  ],
  "dimensions": [
    "AQI_INDEX",
    "CO2_PPM",
    "DISTANCE_LONG",
    "HUMIDITY_PCT",
    "NOISE_DB",
    "PM_CONCENTRATION",
    "PRESSURE",
    "RAIN",
    "RAIN_RATE",
    "SOLAR_IRRADIANCE",
    "SPEED",
    "TEMPERATURE",
    "UV_INDEX"
  ]
}
